import styled, { css } from 'styled-components';
import { Col, Image, ListGroup, Row } from 'react-bootstrap';
import { Link } from '../shared/simple/Link';
import { Logo } from '../shared/simple/Logo';
import { theme } from '../../theme/theme';
import { optionColor, optionColorHover } from '../../helpers/shared';
import {AlertHeading} from 'react-bootstrap';


const { sixth, first, firstHover, third } = theme;

// Define element styles for the component
export const Div = styled.div`
  background: ${sixth};
  left: 0;
  padding: 150px 0 100px 0;
  position: relative;
  top: 0;

  @media (max-width: 767px) {
    background: ${first};
    padding-bottom: 10px;
    height: 100%;
    padding: 130px 0 100px 0;
  }
`;

export const StepsContainerV1 = styled.div`
width: 100%;
  display: flex;
  align-items: center;
`;

export const StepsContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 8px 4px 8px;

  .step-circle {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 2px solid var(--inactive-color, rgba(0,0,0,0.2));
    box-sizing: border-box;
    margin-bottom: 6px;
    transition: all 200ms ease-in-out;
    background: transparent; // inner transparent 
    z-index: 1;
  }

  .step-item.done .step-circle{
    border-color: var(--active-color);
    background-color: color-mix(in srgb, var(--active-color), transparent 75%);
    }

  .step-item.done::after{
    background: var(--active-color);
  }

  .step-label{
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100px;
    z-index: 1;
  }
`;

export const StepItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    flex: 1 1 0;
    min-width: 0;
    text-align: center;
    padding: 0 6px;
    position: relative;

    &:last-child::after{
      display: none;
    }

    &::after{
      // connector line to next step
      content: '';
      position: absolute;
      top: 9px; // center of circle (18px/2)
      right: calc(-50% + 9px);
      height: 2px;
      width:calc(100% - 16px);
      background: var(--inactive-color, rgb(23, 124, 224));
      z-index: -10;
    }
`

export const StepCircle = styled.div`
`

export const StyledCol = styled(Col)`
  padding-left: 10%;
  overflow: hidden;

  @media (max-width: 767px) {
    padding: 5%;
  }
`;

export const StyledDiv = styled(Div)`
  @media (max-width: 767px) {
    background: ${sixth};
  }

  @media (max-width: 767px) {
    padding: 60px 0 60px 0;
  }

`;

export const ProductsContainer = styled(Div)`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  background: transparent;
  padding: 0;
  @media (max-width: 767px) {
    justify-content: center;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const StyledImage = styled(Image)`
  height: 100%;
  left: 0;
  opacity: 0.5;
  position: absolute;
  top: 0;
  width: -webkit-fill-available;
`;

export const ProductItem = styled(Image)`
  height: 130px;
  width: 165px;
  margin: 15px 10px 4px;
  cursor: pointer;
  aspect-ratio: 3/2;
  object-fit: contain;

  @media (max-width: 1200px) {
    height: 100px;
    width: 150px;
  }

  @media (max-width: 767px) {
    width: -webkit-fill-available;
    object-fit: contain;
  }
`;

export const SingleProductContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor:pointer;
  color: #6c757d;
  font-size:12px;

  @media (min-width: 768px) {
    font-size: 14px;
  }

  p{
    transition: .3s all;
    font-family: 'Roboto', sans-serif;
  }

  &:hover{
    p{
      transition: .3s all;
      text-shadow: .25px .25px #6c757d;
      color: hsl(208, 7%, 10%);
    }
  }

`

export const StyledLink = styled(Link)`
  font-size: inherit;
  cursor: pointer;
`;

export const StyledLogo = styled(Logo)`
  @media (max-width: 767px) {
    left: 0;
    right: 0;
    text-align: center;
    top: 20px;
    z-index: 1001;
  }
`;

export const StyledRow = styled(Row).withConfig({
  shouldForwardProp: (prop) => prop !== 'isNewDesign',
})`
  border-radius: 20px;
  padding: 30px 15px;
  position: relative;

  ${({ isNewDesign }) => isNewDesign ? css`
    /* Glassmorphism effect */
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    margin-top: 0;
    box-shadow: 0 0 30px 0px rgba(0, 0, 0, 0.3);
  ` : css`
    background: ${sixth};
  `}

`;
 

export const LogOutButton = styled.div`
 position: absolute;
 right: 20px;
 top: 20px;
 cursor: pointer;
`;

export const H1 = styled.h1`
  @media (max-width: 767px) {
    font-size: 24px;
  }
`

export const UserName = styled.h1`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
`

export const Greeting = styled.div`
  display:flex;
  justify-content: center;
`

export const H4 = styled.h4`
  @media (max-width: 767px) {
    font-size: 16px;
  }
`

export const CustomAlertHeading = styled(AlertHeading)`
  font-size: 2rem;


  /* tablets/medium sized */
  @media (max-width: 768px) {
    font-size: 1.5rem; 
  }

  /* Mobile */
  @media (max-width: 480px) {
    font-size: 1.2rem;
  }
`

export const Img = styled.img`
  border-radius: 50%;
  position: relative;
  height: ${({customImgWidth}) => customImgWidth ? customImgWidth : '200px'};
  width: ${({customImgWidth}) => customImgWidth ? customImgWidth : '200px'};

  @media (max-width: 767px) {
    height: ${({customImgWidth, customImgWidthXs}) => (customImgWidthXs || customImgWidth) ? (customImgWidthXs || customImgWidth) : '150px'};
    width: ${({customImgWidth, customImgWidthXs}) => (customImgWidthXs || customImgWidth) ? (customImgWidthXs || customImgWidth) : '150px'};
  }
`;

export const CloseImage = styled.img`
  position: absolute;
  width: 20px;
  height: 20px;
  top: 10px;
  right: 10px;
`;

export const InputFile = styled.input.attrs({ type: 'file' })`
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0;
  cursor: pointer !important;
  background-color:rgba(245, 245, 245, 0);
  transition: background-color 0.3s ease;

  &:hover,
  &:focus {
    cursor: pointer;
    background-color: #f4f9fc;
  }
`;

export const InputFileExport = styled.input.attrs({ type: 'file' })`
  display: none;
`;

export const LabelButtonUploadFile = styled.label`
  color: white;
  background-color: ${props => optionColor(props.color)};
  border-color: ${props => optionColor(props.color)};
  margin: 7px 0;
  width: 100%;
  &:hover,
  &:active,
  &:focus,
  &:focus-visible {
    color: white;
    background-color: ${props => optionColorHover(props.color)};
    border-color: ${props => optionColorHover(props.color)};
  }
// `;

// Avatar
export const DivAvatar = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 200px;
  position:relative;

  @media (max-width: 767px) {
    margin-top: ${ ({customMarginTopXs}) => customMarginTopXs ? customMarginTopXs : '0px' };
    justify-content: ${ ({customJustifyContentXs}) => customJustifyContentXs ? customJustifyContentXs : 'flex-start' }
  }
`;

export const Upload = styled.div`
  align-self: flex-end;
  /* background-color: ${first}; */
  background-color: ${ ({customBgColor}) => customBgColor ? customBgColor : first};

  border-radius: 50%; 
  border: 2px solid transparent;
  height: 48px;
  position: absolute;
  bottom: 0px;
  transform: translateX(50px);
  width: 48px;
  cursor: pointer;

  transition: 250ms all ease-in;
  &:hover,
  &:focus {
    cursor: pointer;
    background-color: ${ ({customBgColorHover}) => customBgColorHover ? customBgColorHover : firstHover};
  }

  @media (max-width: 767px) {
    transform: translateX(40px);
  }
`;

export const FileButton = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 300px;
  height: 200px;
  border: 1px #c4c4c4 solid;
  border-radius: 10px;
  cursor: pointer;
  background-color:rgba(245, 245, 245, 0);
  transition: background-color 0.3s ease;

  &:hover,
  &:focus {
    cursor: pointer;
    background-color: #f4f9fc;
  }
`;

export const FileIcon = styled.img`
  max-width: 100%;
  max-height: 100%;
  height: auto;
  padding: 10px;
`;

export const FileIconModal = styled.img`
  width: 100%;
  height: 100%;
  padding: 40px;
`;

export const FileInputContainer = styled.div`
  width: 100%;
`;

export const InputRtc = styled.input`
  opacity: 0;
  position: absolute;
  z-index: -10;
`

export const SectionFront = styled.section`
  height: 100%;
  width: 100%;
  backface-visibility: hidden;
  position: relative;
` 

export const SectionContainer = styled.div`
  transition: all 1s;
  position: relative;
  box-sizing: border-box;

  ol{
    list-style-position: inside;
    padding-inline: 1rem;
  }
`

export const BtnContainer = styled.div`
  display:flex;
  gap: 4px;
  @media screen and (min-width: 992){
    max-width: 80%;
  }
`

export const InstructionSection = styled.section`
  padding-inline: 16px;
`

export const StyledDialogTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledMobileOption = styled.div`
    font-size: 14px;
    margin-bottom: 1em;
    bottom: 0;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
`

export const SignatureClearButton = styled.button`
  background: transparent;
  border: transparent;
  position: absolute;
  left: 5px;
  bottom: 5px;
`;

export const ListItem = styled(ListGroup.Item)`
  padding: 20px !important;

  &:active,
  &.active,
  &.list-group-item.active {
    background-color: ${first} !important;
    border-color: ${first} !important;
    color: white;
    z-index: unset;
  }
`;

export const FileVideo = styled.video`
  width: 100%;
  height: 100%;
  padding: 10px;
`;
